import React from 'react';
import '../App.css';
import Headerappprivate from './appPrivate/headerappprivate'
import { Bodyappmovwalletreportbody} from './bodyappmovwalletreportbody'
import { Footerappprivate } from './appPrivate/footerappprivate'
import withRouter from './withRouter'
class Bodyappmovwalletreport extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
          if(this.props.params.loginToken == '')
          {
              window.location = ('/')
          }

  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivate/>
        <Bodyappmovwalletreportbody />
        <Footerappprivate/>
      </div>
    );
  }
}
export default withRouter(Bodyappmovwalletreport);